import { Toast } from 'drywall';
import { css } from 'styled-components';
import token from 'styled-token';
import { marginMixin } from '../marginMixin';
import { spaceMixin } from '../spaceMixin';
import { statusDialogMixin } from '../statusDialogMixin';

/** @class AlertMixin */
/** @method */
export var AlertMixin = function AlertMixin(props) {
  return token({
    borderRadius: 'Alert.borderRadius',
    toastActionFlex: 'Alert.Toast.Action.flex',
    toastActionIconSize: 'Alert.Toast.Action.iconSize',
    toastActionMarginLeft: 'Alert.Toast.Action.marginLeft',
    toastActionMarginTop: 'Alert.Toast.Action.marginTop',
    toastActionOrder: 'Alert.Toast.Action.order',
    toastBodyFlex: 'Alert.Toast.Body.flex'
  }, function (_ref) {
    var _ref$borderRadius = _ref.borderRadius,
      borderRadius = _ref$borderRadius === void 0 ? 0 : _ref$borderRadius,
      _ref$toastActionFlex = _ref.toastActionFlex,
      toastActionFlex = _ref$toastActionFlex === void 0 ? '1 1 100%' : _ref$toastActionFlex,
      toastActionIconSize = _ref.toastActionIconSize,
      toastActionMarginLeft = _ref.toastActionMarginLeft,
      toastActionMarginTop = _ref.toastActionMarginTop,
      _ref$toastActionOrder = _ref.toastActionOrder,
      toastActionOrder = _ref$toastActionOrder === void 0 ? 2 : _ref$toastActionOrder,
      _ref$toastBodyFlex = _ref.toastBodyFlex,
      toastBodyFlex = _ref$toastBodyFlex === void 0 ? '1 1 0' : _ref$toastBodyFlex;
    return css(["", " border-radius:", "px;", "{flex:", ";}flex-flow:row wrap;", "{margin-left:", "px;margin-top:", ";order:", ";flex:", ";}", ""], statusDialogMixin(props), borderRadius, Toast.Body, toastBodyFlex, Toast.Action, spaceMixin(toastActionMarginLeft, function (space) {
      return space.value + toastActionIconSize;
    })(props), toastActionMarginTop ? toastActionMarginTop + "px" : spaceMixin('xs')(props), toastActionOrder, toastActionFlex, marginMixin(props));
  })(props);
};